import { render } from "./UserScreen.vue?vue&type=template&id=62b96912&scoped=true"
import script from "./UserScreen.vue?vue&type=script&lang=js"
export * from "./UserScreen.vue?vue&type=script&lang=js"

import "./UserScreen.vue?vue&type=style&index=0&id=62b96912&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b96912"]])

export default __exports__